var Base64 = require('./base64.js');

/**
 * A companion to obfuscate.js
 */
String.prototype.clarify = function () {
    return JSON.parse(Base64.decode(this));
};
